"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment = __importStar(require("moment"));
const React = __importStar(require("react"));
const react_datepicker_1 = __importDefault(require("react-datepicker"));
const utils_1 = require("core/utils");
// import Event from "../../models/event"; // Missing dependency
const teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
require("react-datepicker/dist/react-datepicker.css");
require("./date-picker.scss");
// validation for date picker is handled in the from itself
class DatePicker extends React.PureComponent {
    picker;
    onSelect = (date) => {
        this.props.onValidChange(true);
        this.props.onChange({
            target: { name: this.props.name, value: (0, utils_1.formatDateForServer)(date) },
        });
    };
    onChange(date, change) {
        if (!date || date === '') {
            // @ts-ignore
            this.onSelect(null);
            this.props.onValidChange(true);
        }
        else {
            const moment = (0, utils_1.parseDate)(date, 'M/D/YYYY');
            if (moment.isValid()) {
                this.onSelect(moment);
                this.props.onValidChange(true);
            }
            else {
                change('plainBirthdate', date.target.value);
                // @ts-ignore
                this.onSelect(null);
                this.props.onValidChange(false);
            }
        }
    }
    render() {
        const { value, dateProps, className, name, change } = this.props;
        const displayedValue = value ? moment.default(value).format('M/D/YYYY') : null;
        const selectedValue = value ? moment.default(value) : null;
        return (React.createElement("div", { className: "date-picker", "data-testid": "date-picker" },
            React.createElement(react_datepicker_1.default, { ref: (ref) => {
                    this.picker = ref;
                }, ...dateProps, popperModifiers: {
                    preventOverflow: {
                        enabled: true,
                        escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                        boundariesElement: 'viewport',
                    },
                }, className: className, value: displayedValue, selected: selectedValue, name: name, onSelect: this.onSelect, onChangeRaw: (e) => this.onChange(e, change), dropdownMode: "select", dateFormat: "M/D/YYYY" }),
            React.createElement("div", { onClick: () => this.picker.onInputClick(), className: "calendar" },
                React.createElement(teamsnap_ui_1.Icon, { name: "schedule" }))));
    }
}
exports.default = DatePicker;
